import request from '@/utils/request'

// 协议列表
export function getInfoByType(data) {
  return request({
    url: '/app/api/common/getHtmlContentByType/v1_0_0?type=' + data.type,
    method: 'get',
  })
}


// WEBPACK FOOTER //
// ./src/api/user.js